import React, { useState } from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { fireGtmEvent } from "../../../utils/googleAnalytics";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { available } from "../../../redux/actions/hotelInfoAction";
import styles from "./CheckOutCancellation.module.css";
import { IoChevronDownCircleOutline } from "react-icons/io5";

dayjs.extend(isSameOrAfter);
const CheckOutCancellationPolicy = ({
  cancellationPolicy,
  dateRange,
  // checkInTime,
  noMargin,
  isMiniVersion = false,
  paymentProvider,
  fullWidthList = false,
}) => {
  const [showCancellation, setShowCancellation] = useState(false);
  // console.log("daterange", dateRange, cancellationPolicy);

  const handleToggleCancellation = () => {
    setShowCancellation(!showCancellation);
    showCancellation
      ? fireGtmEvent("cancelClosedLandingPage")
      : fireGtmEvent("cancelViewedLandingPage");
  };

  const { t } = useTranslation();
  const currentDate = dayjs();
  const checkInDate = dayjs(dateRange?.startDate);

  // Default fallback policy when no applicable policies are found

  const closestPolicy = cancellationPolicy
    ?.map((pol) => {
      const daysBeforeArrival = parseInt(
        pol?.variables?.daysBeforeArrival
          ? pol?.variables?.daysBeforeArrival
          : pol?.Days_Before,
        10
      );

      const policyDate =
        daysBeforeArrival == 999
          ? null
          : dayjs(dateRange?.startDate).subtract(daysBeforeArrival, "day");

      const penaltyText =
        daysBeforeArrival == 999
          ? "Non refundable"
          : policyDate?.isSame(dateRange?.startDate, "day")
          ? "On"
          : "From";

      return {
        policyDate,
        penalty: pol?.variables?.chargedPercentage ?? pol?.Penalty_Value,
        penaltyType: pol?.penalty_type ?? "%",
        penaltyText,
        daysBeforeArrival,
      };
    })
    .filter(
      (pol) =>
        pol.policyDate !== null &&
        (!pol.policyDate || pol.policyDate.isBefore(currentDate, "day"))
    )
    .sort((a, b) => a.daysBeforeArrival - b.daysBeforeArrival)[0];

  const defaultPolicy = {
    daysBeforeArrival: closestPolicy?.daysBeforeArrival ?? 0,
    chargedPercentage: +closestPolicy?.penalty || 0,
    policyDate: dateRange,
    penalty: closestPolicy?.penalty || 0,
    penaltyType: closestPolicy?.penaltyType || "%",
    penaltyText: closestPolicy?.penaltyText || t("before"),
  };

  // const applicablePolicies = cancellationPolicy
  //   ?.map((pol) => {
  //     const daysBeforeArrival = parseInt(
  //       pol?.variables?.daysBeforeArrival
  //         ? pol?.variables?.daysBeforeArrival
  //         : pol?.Days_Before,
  //       10
  //     );

  //     const policyDate =
  //       daysBeforeArrival == 999
  //         ? null
  //         : dayjs(dateRange?.startDate).subtract(daysBeforeArrival, "day");

  //     const penaltyText =
  //       daysBeforeArrival == 999
  //         ? "Non refundable"
  //         : policyDate?.isSame(dateRange?.startDate, "day")
  //         ? "On"
  //         : "From";

  //     // return {
  //     //   policyDate: policyDate,
  //     //   penalty: pol?.variables?.chargedPercentage
  //     //     ? pol?.variables?.chargedPercentage
  //     //     : pol?.Penalty_Value,
  //     //   penaltyType: pol?.penalty_type ? pol?.penalty_type : "%",
  //     //   penaltyText: penaltyText,
  //     //   daysBeforeArrival: daysBeforeArrival,
  //     // };
  //     return {
  //       policyDate,
  //       penalty: pol?.variables?.chargedPercentage ?? pol?.Penalty_Value,
  //       penaltyType: pol?.penalty_type ?? "%",
  //       penaltyText,
  //       daysBeforeArrival,
  //     };
  //   })
  //   .filter(
  //     (pol) =>
  //       !pol.policyDate || pol.policyDate.isSameOrAfter(currentDate, "day")
  //   );

  // console.log("cancellationPolicy the begin", cancellationPolicy);

  const applicablePolicies = cancellationPolicy
    ?.map((pol) => {
      const daysBeforeArrival = parseInt(
        pol?.variables?.daysBeforeArrival
          ? pol?.variables?.daysBeforeArrival
          : pol?.Days_Before,
        10
      );

      const policyDate =
        daysBeforeArrival == 999
          ? dayjs()
          : dayjs(dateRange?.startDate).subtract(daysBeforeArrival, "day");

      const penaltyText =
        daysBeforeArrival == 999
          ? "Non refundable"
          : policyDate?.isSame(dateRange?.startDate, "day")
          ? "On"
          : "From";

      return {
        policyDate,
        penalty: pol?.variables?.chargedPercentage ?? pol?.Penalty_Value,
        penaltyType: pol?.penalty_type ?? "%",
        penaltyText,
        daysBeforeArrival,
      };
    })
    .filter(
      (pol) =>
        pol.policyDate !== null &&
        (!pol.policyDate || pol.policyDate.isSameOrAfter(currentDate, "day"))
    ); // if no valid policies, fallback to empty array // fallback to array with default policy if empty

  if (applicablePolicies?.length === 0) {
    applicablePolicies.push({
      policyDate: dayjs(dateRange?.startDate),
      penaltyType: "%",
      penaltyText: "Before",
      penalty: defaultPolicy?.chargedPercentage,
      daysBeforeArrival: defaultPolicy.daysBeforeArrival,
    });
  }

  // const freeCancellationPolicy = applicablePolicies.find(
  //   (pol) =>
  //     pol.penalty === 0 ||
  //     pol.daysBeforeArrival >= defaultPolicy.daysBeforeArrival
  // ) || {
  //   ...defaultPolicy,
  //   policyDate: dayjs(dateRange?.startDate).subtract(
  //     defaultPolicy.daysBeforeArrival,
  //     "day"
  //   ),
  //   penaltyText: t("free_cancellation_till"),
  // };

  const freeCancellationPolicyProbar = {
    penalty: 0,
    penaltyType: "%",
    ...defaultPolicy,
    policyDate: dayjs(dateRange?.startDate).subtract(
      Math.max(
        ...(applicablePolicies && applicablePolicies.length > 0
          ? applicablePolicies.map((p) => p.daysBeforeArrival || 0)
          : [0])
      ),
      "day"
    ),
    penaltyText: t("before"),
  };

  const freeCancellationPolicy = dayjs(dateRange?.startDate).isSameOrAfter(
    currentDate,
    "day"
  )
    ? applicablePolicies?.find(
        (pol) =>
          pol.penalty == 0 &&
          pol.daysBeforeArrival >= defaultPolicy.daysBeforeArrival
      ) ||
      (!freeCancellationPolicyProbar?.penalty &&
      !freeCancellationPolicyProbar?.policyDate?.isBefore(
        dayjs(dateRange?.startDate).subtract(998, "day")
      )
        ? freeCancellationPolicyProbar
        : null)
    : null; // Do not display if no applicable policies

  // console.log("freeCancellation", freeCancellationPolicy?.policyDate);
  // console.log(
  //   "freeCancellationPolicybar",
  //   freeCancellationPolicyProbar?.policyDate
  // );

  if (
    applicablePolicies?.length > 0 &&
    applicablePolicies.every((pol) => pol.penalty !== 0) &&
    dayjs(dateRange?.startDate).isAfter(currentDate, "day") &&
    freeCancellationPolicyProbar?.policyDate?.isSameOrAfter?.(currentDate)
  ) {
    applicablePolicies.unshift(freeCancellationPolicyProbar);
  }

  // add one more variable to for end date of policy
  applicablePolicies?.sort((p1, p2) => p2.penalty - p1.penalty);
  // applicablePolicies[0].endDate = dayjs(dateRange?.startDate);
  if (applicablePolicies && applicablePolicies.length > 0) {
    applicablePolicies[0].endDate = dayjs(dateRange?.startDate);
  }

  for (let i = 1; i < applicablePolicies?.length; i++) {
    applicablePolicies[i].endDate = applicablePolicies[i - 1].policyDate;
  }

  // console.log("Default policy", defaultPolicy);
  // console.log("Available policy", applicablePolicies);
  // console.log("Free cancellation policy", freeCancellationPolicy);
  // console.log("Free cancellation probar", freeCancellationPolicyProbar);

  const noRefundPolicy = applicablePolicies
    ?.sort((a, b) => b.daysBeforeArrival - a.daysBeforeArrival)
    ?.find(
      (pol) => pol.penalty == 100
      //  ||  pol.daysBeforeArrival >= defaultPolicy.daysBeforeArrival
    ) || {
    ...defaultPolicy,
    policyDate: dayjs(dateRange?.startDate).subtract(
      defaultPolicy.chargedPercentage == 100
        ? defaultPolicy.daysBeforeArrival
        : 0,
      "day"
    ),
    penaltyText: t("no_refund_if_cancelled_after"),
  };

  if (
    noRefundPolicy?.policyDate &&
    dayjs(noRefundPolicy?.policyDate).isBefore(currentDate)
  ) {
    noRefundPolicy.policyDate = freeCancellationPolicy?.policyDate || dayjs();
  }

  return (
    <div
      className={`landingPage__cancellationPolicyContainer ${
        styles.landingPage__cancellationPolicyContainer
      } ${isMiniVersion ? styles.mini : ""}`}
      // className="landingPage__cancellationPolicyContainer"
      style={{
        //marginBottom: noMargin ? "0" : "80px",
        width: noMargin ? "100%" : "",
        padding: noMargin ? 0 : "20px 40px",
      }}
    >
      <div
        className={styles.cancellation_headerBox}
        style={{ cursor: "pointer" }}
        onClick={handleToggleCancellation}
      >
        <div className={styles.cancellationHeading}>
          <h4>{t("cancellation_refund_policy")}</h4>
          <span>Tap to see cancellation policy & property rules..</span>
        </div>
        <IoChevronDownCircleOutline
          size={24}
          style={{
            transform: showCancellation ? "rotate(180deg)" : "rotate(0)",
            transition: "transform 0.2s ease",
            width: "30px",
            height: "30px",
            color: "#1764D1",
          }}
        />
      </div>
      {showCancellation && (
        <ul style={{ width: fullWidthList ? "100%" : undefined }}>
          <div style={{ color: "black", marginTop: "14px" }}>
            {/* Free cancellation or refund information */}
            {freeCancellationPolicy && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                  gap: "5px",
                }}
              >
                <span style={{ display: "flex" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_508_4918)">
                      <path
                        d="M6.75 9L8.25 10.5L11.25 7.5M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
                        stroke="#199713"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_508_4918">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <span style={{ fontSize: "14px" }}>
                  {t("free_cancellation_until")}{" "}
                  {freeCancellationPolicy?.policyDate?.format("D MMM, h:mm A")}
                </span>
              </div>
            )}

            {noRefundPolicy && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                  gap: "5px",
                }}
              >
                <span style={{ display: "flex" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_508_4918)">
                      <path
                        d="M6.75 9L8.25 10.5L11.25 7.5M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
                        stroke="#199713"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_508_4918">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <span style={{ fontSize: "14px" }}>
                  {t("no_refund_if_cancelled_after")}{" "}
                  {noRefundPolicy.policyDate.format("D MMM, h:mm A")}
                </span>
              </div>
            )}
          </div>
          <div
            className={`${styles.wrapper} ${isMiniVersion ? styles.mini : ""}`}
            style={{
              height: "100px",
              padding: "20px",
              flexShrink: "0",
              marginBottom: "50px",
              marginTop: "20px",
              borderRadius: "4px",
              border: "1px solid var(--Stroke, #D7D2D2)",
              background: "#FFF",
              boxShadow:
                "-52px 54px 21px 0px rgba(204, 199, 199, 0.00), -34px 35px 19px 0px rgba(204, 199, 199, 0.01), -19px 20px 16px 0px rgba(204, 199, 199, 0.05), -8px 9px 12px 0px rgba(204, 199, 199, 0.09), -2px 2px 7px 0px rgba(204, 199, 199, 0.10);",
            }}
          >
            <div
              className={`progressBar ${styles.progressBar} ${
                isMiniVersion ? styles.mini : ""
              }`}
              style={{
                height: "30px",
                position: "relative",
                margin: "0",
                borderRadius: "25px",
                overflow: "hidden",
              }}
            >
              <span
                className={`${styles.circle} ${
                  isMiniVersion ? styles.mini : ""
                }`}
                style={{
                  width: "8vw",
                  height: "8vw",
                  maxWidth: "15px",
                  maxHeight: "15px",
                  borderRadius: "50%",
                  backgroundColor: "white",
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translate(-50%, -50%)",
                  zIndex: 10,
                  border: "2px solid #1870eb",
                }}
              ></span>

              {(() => {
                if (applicablePolicies.length === 0) {
                  return (
                    <div
                      className="progressValue"
                      style={{
                        width: "100%",
                        backgroundColor: "#f8ecc1",
                        color: "#f08732",
                      }}
                    >
                      <span style={{ color: "#f08732" }}>Non refundable</span>
                    </div>
                  );
                }

                return Object.values(
                  applicablePolicies.reduce(
                    (acc, pol) => {
                      const refundPercentage = 100 - pol?.penalty;

                      if (refundPercentage == 100 && !acc.fullRefund) {
                        acc.fullRefund = pol;
                      } else if (
                        refundPercentage > 0 &&
                        refundPercentage < 100
                        //  &&
                        // !acc.partialRefund
                      ) {
                        acc.partialRefund === null
                          ? (acc.partialRefund = pol)
                          : (acc.partialRefund =
                              acc.partialRefund.penalty > pol.penalty
                                ? acc.partialRefund
                                : pol);
                      } else if (refundPercentage == 0 && !acc.noRefund) {
                        acc.noRefund = pol;
                      }

                      return acc;
                    },
                    { fullRefund: null, partialRefund: null, noRefund: null }
                  )
                ).map((policy, id) => {
                  if (!policy) return null;

                  let refundText, backgroundColor, color;
                  const refundPercentage = 100 - policy?.penalty;

                  if (refundPercentage == 100) {
                    refundText = "100% refund";
                    backgroundColor = "#1870eb";
                    color = "white";
                  } else if (refundPercentage > 0 && refundPercentage < 100) {
                    refundText = "Partial refund";
                    backgroundColor = "#eaf7ff";
                    color = "#3f8aef";
                  } else if (refundPercentage == 0) {
                    refundText = "Non refundable";
                    backgroundColor = "#f8ecc1";
                    color = "#f08732";
                  }

                  return (
                    <div
                      key={id}
                      className="progressValue"
                      style={{
                        width: `${policy?.width}%`,
                        background: backgroundColor,
                        borderTopLeftRadius: id === 0 ? "10px" : "",
                        borderBottomLeftRadius: id === 0 ? "10px" : "",
                        borderTopRightRadius: id === 2 ? "10px" : "",
                        borderBottomRightRadius: id === 2 ? "10px" : "",
                      }}
                    >
                      <span
                        style={{
                          color,
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: "600",
                        }}
                      >
                        {refundText}
                      </span>
                      <span
                        className="progressValueText"
                        style={{
                          bottom: "-30px",
                          color: "var(--Grey, #494545)",
                          fontSize: "12px",
                        }}
                      >
                        {policy?.endDate?.format("DD MMM YY")}
                      </span>
                    </div>
                  );
                });
              })()}

              <div
                className={`${styles.circle} ${
                  isMiniVersion ? styles.mini : ""
                }`}
                style={{
                  width: "8vw",
                  height: "8vw",
                  maxWidth: "15px",
                  maxHeight: "15px",
                  borderRadius: "50%",
                  backgroundColor: "white",
                  position: "absolute",
                  top: "50%",
                  right: "10px",
                  transform: "translate(50%, -50%)",
                  zIndex: 10,
                  border: "2px solid #f08732",
                }}
              ></div>
            </div>
          </div>
          {freeCancellationPolicy && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "8px",
                gap: "5px",
                marginTop: "40px",
                color: "black",
              }}
            >
              <span style={{ display: "flex" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <g clip-path="url(#clip0_508_4918)">
                    <path
                      d="M6.75 9L8.25 10.5L11.25 7.5M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
                      stroke="#199713"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_508_4918">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span style={{ fontSize: "14px" }}>
                {t(
                  "free_cancellation_100_refund_if_you_cancel_this_booking_before"
                )}{" "}
                {} {freeCancellationPolicy?.policyDate?.format("D MMM, h:mm A")}
              </span>
            </div>
          )}

          <div style={{ marginBottom: "10px", marginTop: "24px" }}>
            <span
              style={{
                color: "var(--Dark, #171719)",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "normal",
              }}
            >
              {t(
                "cancellation_post_that_will_be_subject_to_a_fee_as_shown_in_the_table"
              )}
            </span>
          </div>
          <div
            style={{
              borderRadius: "6px",
              overflow: "hidden",
            }}
          >
            <table
              style={{
                // border: "1px solid gray",
                borderCollapse: "collapse",
                width: "100%",
                color: "black",
                margin: "0", // Ensure no margin pushes content
                border: "none", // Remove any table border

                // display: "block",
                // borderRadius: "6px",
              }}
            >
              <thead style={{ backgroundColor: "#eaf7ff", color: "black" }}>
                <tr>
                  <th
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                      padding: "8px",
                      fontSize: "14px",
                      textTransform: "uppercase",
                    }}
                  >
                    {t("date")}
                  </th>
                  <th
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                      padding: "8px",
                      fontSize: "14px",
                      textTransform: "uppercase",
                    }}
                  >
                    {t("fee")}
                  </th>
                </tr>
              </thead>
              <tbody style={{ color: "black" }}>
                {applicablePolicies?.length > 0 ? (
                  applicablePolicies.map((pol) => (
                    <tr>
                      <td
                        style={{
                          border: "1px solid #dddddd",
                          textAlign: "left",
                          padding: "8px",
                          color: "var(--Grey, #494545)",
                          fontSize: "14px",
                        }}
                      >
                        {/* {pol?.penaltyText} {pol?.policyDate.format("DD MMM YY")} */}

                        {pol.daysBeforeArrival == 999
                          ? t("no_refund")
                          : `${pol.penaltyText} ${pol?.policyDate?.format(
                              "DD MMM YY"
                            )}`}
                      </td>
                      {/* <td
                      style={{
                        border: "1px solid #dddddd",
                        textAlign: "left",
                        padding: "8px",
                      }}
                    >
                      {t("before")}{" "}
                      {dayjs(dateRange?.startDate)
                        .subtract(
                          parseInt(pol?.variables?.daysBeforeArrival, 10),
                          "day"
                        )
                        .format("D MMM")}
                    </td> */}
                      <td
                        style={{
                          border: "1px solid #dddddd",
                          textAlign: "left",
                          padding: "8px",
                          color: "var(--Grey, #494545)",
                          fontSize: "14px",
                        }}
                      >
                        {/* {pol?.penalty} {""} {pol?.penaltyType}{" "}
                      {t("of_the_booking_amount")} */}

                        {pol.daysBeforeArrival == 999
                          ? t("hundred_percent_of_the_booking_amount")
                          : `${pol.penalty} ${pol.penaltyType} ${t(
                              "of_the_booking_amount"
                            )}`}
                      </td>
                    </tr>
                  ))
                ) : (
                  // Render default "No charge before 2 days" row
                  <tr>
                    <td
                      style={{
                        border: "1px solid #dddddd",
                        textAlign: "left",
                        padding: "8px",
                      }}
                    >
                      {t("From")}{" "}
                      {dayjs(dateRange?.startDate)
                        .subtract(defaultPolicy.daysBeforeArrival, "day")
                        ?.format("D MMM")}
                    </td>
                    <td
                      style={{
                        border: "1px solid #dddddd",
                        textAlign: "left",
                        padding: "8px",
                      }}
                    >
                      {defaultPolicy.chargedPercentage}%{" "}
                      {t("of_the_booking_amount")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "8px",
              gap: "5px",
              marginTop: "5px",
            }}
          >
            <span style={{ display: "flex" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M6.91667 12.9163C10.1843 12.9163 12.8333 10.2674 12.8333 6.99967C12.8333 3.73199 10.1843 1.08301 6.91667 1.08301C3.64898 1.08301 1 3.73199 1 6.99967C1 10.2674 3.64898 12.9163 6.91667 12.9163Z"
                  fill="#171719"
                  stroke="#171719"
                  stroke-width="1.33333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <span
              style={{
                padding: "10px 0px",
                display: "flex",
                color: "black",
                fontSize: "14px",
              }}
            >
              {t(
                "cancellation_are_only_allowed_before_checkin_time_all_the_time_mentioned_above_is_in_destination_time"
              )}
            </span>
            {paymentProvider?.subVendor === "hotelzify" ? (
              <span
                className={styles.tooltipContainer}
                onMouseEnter={(e) => {
                  fireGtmEvent("fee_viewed");
                  const tooltip = e.currentTarget.querySelector(
                    `.${styles.tooltip}`
                  );
                  if (tooltip) {
                    tooltip.style.visibility = "visible";
                    tooltip.style.opacity = "1";
                  }
                }}
                onMouseLeave={(e) => {
                  const tooltip = e.currentTarget.querySelector(
                    `.${styles.tooltip}`
                  );
                  if (tooltip) {
                    tooltip.style.visibility = "hidden";
                    tooltip.style.opacity = "0";
                  }
                }}
                // Add touch support for mobile devices
                onClick={(e) => {
                  const tooltip = e.currentTarget.querySelector(
                    `.${styles.tooltip}`
                  );
                  if (tooltip) {
                    const isVisible = tooltip.style.visibility === "visible";
                    tooltip.style.visibility = isVisible ? "hidden" : "visible";
                    tooltip.style.opacity = isVisible ? "0" : "1";
                  }
                }}
              >
                <div className={styles.tooltipTrigger}>
                  <span>?</span>
                </div>
                <div className={styles.tooltip}>
                  {t("processing_fee_notice_mainpage")}
                </div>
              </span>
            ) : null}
          </div>
        </ul>
      )}
    </div>
  );
};

export default CheckOutCancellationPolicy;
